import { render, staticRenderFns } from "./HousingCommitteeNotes.vue?vue&type=template&id=3de6c61c&scoped=true&"
import script from "./HousingCommitteeNotes.vue?vue&type=script&lang=js&"
export * from "./HousingCommitteeNotes.vue?vue&type=script&lang=js&"
import style0 from "./HousingCommitteeNotes.vue?vue&type=style&index=0&id=3de6c61c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3de6c61c",
  null
  
)

export default component.exports